import BranchService from "../branch/BranchService";
import AttachmentService from "../../attachments/AttachmentService";
import _ from "lodash";
import {
  SOURCE_BRANCH_ITEM_LOCATIONS,
  SOURCE_ITEM_LOCATION_MOVE_MODAL,
  SOURCE_PRE_BIDS_TABLE
} from "@/modules/constants";
import ChargeService from "@/modules/setup/branch/tabs/charges/ChargeService";
import ItemLocationService from "@/modules/setup/branch/ItemLocationService";
import EventBus from "@/plugins/event-bus";
import {UPDATE_ITEM_LOCATION_MOVE_MODAL_DATA} from "@/plugins/event-bus/event-bus-names";

const branch = {
  namespaced: true,
  state: {
    modal: {
      show: false
    },
    branches: {
      loading: false,
      rows: []
    },
    selectedBranch: null,
    itemLocationsLoading: false,
    itemLocations: null,
    itemLocationModal: {
      object: null,
      show: false,
      parentItemLocation: null,
      source: null
    },
    clerksModal: {
      object: null,
      show: false,
      source: null
    },
    languageModal: {
      object: null,
      show: false,
      source: null
    },
    chargesModal: {
      object: null,
      show: false,
      source: null,
    },
    trustLevelsModal: {
      object: null,
      show: false
    },
    selectedBranchLogo: null,
    charges: [],
  },
  actions: {
    showModal({commit}) {
      commit('showModal');
    },
    hideModal({commit}) {
      commit('hideModal');
    },
    async getBranches({commit}) {
      commit('changeBranchesLoading');
      const res = await BranchService.getBranches({
        expand: 'languages,clerks,clerks.languages,logo,charges,trust_levels'
      });
      const {success, body} = res;
      if (success) {
        commit('getBranches', body);
      }
      commit('changeBranchesLoading');
      return res;
    },
    selectBranch({commit}, branch) {
      commit('selectBranch', branch);
    },
    async createBranch({commit}, payload) {
      const res = await BranchService.createBranch(payload, 'item_locations.created_by');

      const {success, body} = res;
      if (success) {
        commit('createBranch', body);
        commit('selectBranch', body);
      }

      return res;
    },
    async updateBranch({commit, rootState}, payload) {
      const res = await BranchService.updateBranch(
        payload.uuid,
        payload,
        'item_locations.created_by,currency,languages,clerks,clerks.languages,logo,trust_levels,vendor_charges.data.created_by'
      );
      const {success, body} = res;

      if (success) {
        if (rootState.global.currentBranch.uuid === body.uuid) {
          rootState.global.currentBranch = {
            ...rootState.global.currentBranch,
            ...body
          };
        }

        commit('updateBranch', body);
      }
      return res;
    },
    async removeBranch({commit, state}, uuid) {
      const res = await BranchService.removeBranch(uuid);

      const {success} = res;
      if (success) {
        commit('removeBranch', uuid);
        // Select first branch
        commit('selectBranch', state.branches.rows[0]);
      }

      return res;
    },
    showClerksModal({commit}, {object = null, source} = {}) {
      commit('showClerksModal', {object: _.cloneDeep(object), source});
    },
    hideClerksModal({commit}) {
      commit('hideClerksModal');
    },
    showLanguageModal({commit}, {object = null, source} = {}) {
      commit('showLanguageModal', {object: _.cloneDeep(object), source});
    },
    hideLanguageModal({commit}) {
      commit('hideLanguageModal');
    },
    showChargesModal({commit}, {object = null, source} = {}) {
      commit('showChargesModal', {object: _.cloneDeep(object), source});
    },
    hideChargesModal({commit}) {
      commit('hideChargesModal');
    },
    showItemLocationModal({commit}, {object = null, source, parentItemLocation} = {}) {
      commit('showItemLocationModal', {object: _.cloneDeep(object), source, parentItemLocation});
    },
    hideItemLocationModal({commit}) {
      commit('hideItemLocationModal');
    },
    async getItemLocations({state, commit}) {
      commit('toggleItemLocationsLoading', true)
      let response = await ItemLocationService.getItemLocations({
        branch_uuid: state.selectedBranch.uuid, expand: "children", level: 0
      });
      if (response.success) {
        state.itemLocations = response.body;
      } else {
        state.itemLocations = null;
      }
      commit('toggleItemLocationsLoading', false)
      return response
    },
    async createItemLocation({dispatch, state}, itemLocation) {
      let response = await BranchService.createItemLocation(itemLocation, 'created_by');
      if (response.success) {
        dispatch("global/getItemLocations", {}, {root: true})
        if (state.itemLocationModal.source === SOURCE_BRANCH_ITEM_LOCATIONS) {
          dispatch('getItemLocations')
        } else if (state.itemLocationModal.source === SOURCE_ITEM_LOCATION_MOVE_MODAL) {
          EventBus.$emit(UPDATE_ITEM_LOCATION_MOVE_MODAL_DATA, true);
        }
      }
      return response;
    },
    async updateItemLocation({dispatch, state}, {requestData}) {
      let response = await BranchService.updateItemLocation(requestData.uuid, requestData);
      if (response.success) {
        dispatch("global/getItemLocations", {} ,{root: true})
        if (state.itemLocationModal.source === SOURCE_BRANCH_ITEM_LOCATIONS) {
          dispatch('getItemLocations')
        } else if (state.itemLocationModal.source === SOURCE_ITEM_LOCATION_MOVE_MODAL) {
          EventBus.$emit(UPDATE_ITEM_LOCATION_MOVE_MODAL_DATA, true);
        }
      }
      return response;
    },
    async removeItemLocation({dispatch}, {itemLocation, source}) {
      let response = await BranchService.removeItemLocation(itemLocation.uuid);
      if (response.success) {
        dispatch("global/getItemLocations", {} ,{root: true})
        console.log(source);
        if (source === SOURCE_BRANCH_ITEM_LOCATIONS) {
          dispatch('getItemLocations')
        } else if (source === SOURCE_ITEM_LOCATION_MOVE_MODAL) {
          EventBus.$emit(UPDATE_ITEM_LOCATION_MOVE_MODAL_DATA, true);
        }
      }
      return response;
    },
    async removeClerk({commit, rootState}, clerk) {
      let response = await BranchService.removeClerk(clerk.uuid);
      if (response.success) {
        commit('removeClerk', clerk);
        if (rootState.global.currentBranch.uuid === clerk.branch_uuid) {
          rootState.global.currentBranch.clerks = rootState.global.currentBranch.clerks.filter(c => c.uuid !== clerk.uuid);
        }
      }
      return response;
    },
    async createClerk({commit, state, rootState}, clerk) {
      let {name, language_uuids, branch_uuid} = clerk
      let data = {name, language_uuids, branch_uuid}
      let response = await BranchService.createClerk(data, 'languages');
      if (response.success) {

        if (state.clerksModal.source !== SOURCE_PRE_BIDS_TABLE) {
          commit('createClerk', response.body);
        }
        if (rootState.global.currentBranch.uuid === clerk.branch_uuid) {
          rootState.global.currentBranch.clerks.push(response.body);
        }
      }
      return response;
    },
    async updateClerk({commit, rootState}, clerk) {
      let response = await BranchService.updateClerk(clerk.uuid, clerk, 'languages');
      if (response.success) {
        const clerk = response.body;

        if (rootState.global.currentBranch.uuid === clerk.branch_uuid) {
          for (let i = 0; i < rootState.global.currentBranch.clerks.length; i++) {
            if (rootState.global.currentBranch.clerks[i].uuid === clerk.uuid) {
              rootState.global.currentBranch.clerks[i] = clerk;
              break;
            }
          }
        }
        commit('updateClerk', response.body);
      }
      return response;
    },
    async createLanguage({commit, state, rootState}, language) {
      let response = await BranchService.createLanguage(language);
      if (response.success) {
        const language = response.body;
        if (language.is_primary) {
          state.selectedBranch.languages.forEach(il => il.is_primary = false)
          if (rootState.global.currentBranch.uuid === language.branch_uuid) {
            rootState.global.currentBranch.languages.forEach(il => il.is_primary = false);
          }
        }

        commit('createLanguage', response.body);

        if (rootState.global.currentBranch.uuid === language.branch_uuid) {
          rootState.global.currentBranch.languages.push(language);
        }
      }
      return response;
    },
    async updateLanguage({commit, state, rootState}, language) {
      let response = await BranchService.updateLanguage(language.uuid, language);
      if (response.success) {
        const language = response.body;

        if (language.is_primary) {
          state.selectedBranch.languages.forEach(il => il.is_primary = false)
          if (rootState.global.currentBranch.uuid === language.branch_uuid) {
            rootState.global.currentBranch.languages.forEach(il => il.is_primary = false);
          }
        }

        commit('updateLanguage', response.body);

        if (rootState.global.currentBranch.uuid === language.branch_uuid) {
          for (let i = 0; i < rootState.global.currentBranch.languages.length; i++) {
            if (rootState.global.currentBranch.languages[i].uuid === language.uuid) {
              rootState.global.currentBranch.languages[i] = language;
              break;
            }
          }
        }

      }
      return response;
    },
    async removeLanguage({commit, rootState}, language) {
      commit('removeLanguage', language.uuid);
      if (rootState.global.currentBranch.uuid === language.branch_uuid) {
        rootState.global.currentBranch.languages = rootState.global.currentBranch.languages.filter(l => l.uuid !== language.uuid);
      }
    },
    async createBranchLogo(state, {formData, onUploadProgress}) {
      let response = await AttachmentService.createAttachments(formData, onUploadProgress, 'branches');
      return response;
    },
    async deleteBranchLogo(state, payload) {
      let response = await AttachmentService.deleteAttachment(payload, 'branches');
      return response;
    },
    async updateSelectedBranchLogo({commit}, payload) {
      commit('updateSelectedBranchLogo', payload)
    },
    async getCharges({commit}) {
      let response = await BranchService.getCharges();
      if (response.success) commit('getCharges', response.body);

      return response
    },
    async updateCharge({commit}, charge) {
      let response = await ChargeService.updateCharge(charge.uuid, charge, 'created_by');

      if (response.success) {
        const charge = response.body;
        commit('updateCharge', charge);
      }
      return response;

    },
    async removeTrustLevel({commit, rootState}, trustLevel) {
      let response = await BranchService.removeTrustLevel(trustLevel.uuid);
      if (response.success) {
        commit('removeTrustLevel', trustLevel);
        if (rootState.global.currentBranch.uuid === trustLevel.branch_uuid) {
          rootState.global.currentBranch.trust_levels = rootState.global.currentBranch.trust_levels.filter(c => c.uuid !== trustLevel.uuid);
        }
      }
      return response;
    },
    async createTrustLevel({commit, state, rootState}, trustLevel) {
      let response = await BranchService.createTrustLevel(trustLevel);
      if (response.success) {
        commit('createTrustLevel', response.body);
        if (rootState.global.currentBranch.uuid === trustLevel.branch_uuid) {
          rootState.global.currentBranch.trust_levels.push(response.body);
        }
      }
      return response;
    },
    async updateTrustLevel({commit, rootState}, trustLevel) {
      let response = await BranchService.updateTrustLevel(trustLevel.uuid, trustLevel);
      if (response.success) {
        const tmpTrustLevel = response.body;

        if (rootState.global.currentBranch.uuid === trustLevel.branch_uuid) {
          for (let i = 0; i < rootState.global.currentBranch.trust_levels.length; i++) {
            if (rootState.global.currentBranch.trust_levels[i].uuid === tmpTrustLevel.uuid) {
              rootState.global.currentBranch.trust_levels[i] = tmpTrustLevel;
              break;
            }
          }
        }
        commit('updateTrustLevel', response.body);
      }
      return response;
    },
  },
  mutations: {
    showItemLocationModal: (state, {object, source, parentItemLocation}) => {
      state.itemLocationModal.show = true;
      state.itemLocationModal.object = object;
      state.itemLocationModal.source = source;
      state.itemLocationModal.parentItemLocation = parentItemLocation;
    },
    hideItemLocationModal: (state) => {
      state.itemLocationModal.show = false
      state.itemLocationModal.object = null;
      state.itemLocationModal.source = null;
      state.itemLocationModal.parentItemLocation = null;
    },
    showClerksModal: (state, {object, source}) => {
      state.clerksModal.object = object;
      state.clerksModal.source = source;
      state.clerksModal.show = true;
    },
    hideClerksModal: (state) => state.clerksModal.show = false,
    showLanguageModal: (state, {object, source}) => {
      state.languageModal.show = true;
      state.languageModal.object = object;
      state.languageModal.source = source;
    },
    hideLanguageModal: (state) => state.languageModal.show = false,
    showChargesModal: (state, {object, source}) => {
      state.chargesModal.show = true;
      state.chargesModal.object = object;
      state.chargesModal.source = source;
    },
    hideChargesModal: (state) => state.chargesModal.show = false,
    removeClerk(state, clerk) {
      state.selectedBranch.clerks = state.selectedBranch.clerks.filter(i => i.uuid !== clerk.uuid);
    },
    removeLanguage(state, language_uuid) {
      state.selectedBranch.languages = state.selectedBranch.languages.filter(i => i.uuid !== language_uuid);
    },
    createClerk(state, clerk) {
      state.selectedBranch.clerks.push(clerk);
    },
    createLanguage(state, clerk) {
      state.selectedBranch.languages.push(clerk);
    },
    showModal: state => state.modal.show = true,
    hideModal: state => state.modal.show = false,
    getBranches: (state, branches) => {
      state.branches.rows = branches;
      if (!state.selectedBranch) {
        state.selectedBranch = branches[0];
      }
    },
    changeBranchesLoading: state => state.branches.loading = !state.branches.loading,
    selectBranch: (state, branch) => state.selectedBranch = branch,
    createBranch: (state, branch) => state.branches.rows.unshift(branch),
    updateBranch: (state, branch) => {
      const index = state.branches.rows.findIndex(b => b.uuid === branch.uuid);
      state.branches.rows[index] = branch;

      if (state.selectedBranch && branch.uuid === state.selectedBranch.uuid) {
        state.selectedBranch = {...branch};
      }
    },
    updateClerk: (state, clerk) => {
      const index = state.selectedBranch.clerks.findIndex(c => c.uuid === clerk.uuid);
      state.selectedBranch.clerks[index] = clerk;
      state.selectedBranch.clerks = [...state.selectedBranch.clerks];
    },
    updateLanguage: (state, language) => {
      const index = state.selectedBranch.languages.findIndex(c => c.uuid === language.uuid);
      state.selectedBranch.languages[index] = language;
      state.selectedBranch.languages = [...state.selectedBranch.languages];
    },
    removeBranch: (state, uuid) => {
      state.branches.rows = state.branches.rows.filter(b => b.uuid !== uuid);
    },
    updateSelectedBranchLogo(state, attachment) {
      state.selectedBranchLogo = attachment;
    },
    getCharges(state, data) {
      state.charges = data.results
    },
    updateCharge(state, charge) {
      const index = state.charges.findIndex(i => i.uuid === charge.uuid);
      state.charges[index] = {...state.charges[index], ...charge};
      state.charges = [...state.charges]
    },
    toggleItemLocationsLoading: (state, payload) => state.itemLocationsLoading = payload,
    removeTrustLevel(state, trustLevel) {
      state.selectedBranch.trust_levels = state.selectedBranch.trust_levels.filter(i => i.uuid !== trustLevel.uuid);
    },
    showTrustLevelModal: (state, object) => {
      state.trustLevelsModal.show = true;
      state.trustLevelsModal.object = object;
    },
    hideTrustLevelModal: (state) => {
      state.trustLevelsModal.show = false;
      state.trustLevelsModal.object = null;
    },
    createTrustLevel(state, trustLevel) {
      state.selectedBranch.trust_levels.push(trustLevel);
    },
    updateTrustLevel: (state, trustLevel) => {
      const index = state.selectedBranch.trust_levels.findIndex(c => c.uuid === trustLevel.uuid);
      state.selectedBranch.trust_levels[index] = trustLevel;
      state.selectedBranch.trust_levels = [...state.selectedBranch.trust_levels];
    },
  }
};

export default branch;
